import React from 'react';

const fileTypeIconMap = {
    "Audio": "/Content/img/icons/volume-up.svg",
    "Bookmark": "/Content/img/icons/bookmark.svg",
    "Document": "/Content/img/icons/file-earmark.svg",
    "Note": "/Content/img/icons/sticky.svg",
    "Video": "/Content/img/icons/film.svg",
}

const File = ({file}) => {
    let iconSrc = "/Content/img/icons/file-earmark.svg";
    if (fileTypeIconMap[file.type]) {
        iconSrc = fileTypeIconMap[file.type];
    }

    let active = window.location.href.includes(file.id);

    return (
        <li>
            <img className="file-icon" src={iconSrc} alt=""/>
            <a className={`file-link ${active ? 'active-file' : ''}`} href={'#encyclopedia/' + file.id}>{file.title}</a>
        </li>
    );
}

export default File;